var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('iframe',{attrs:{"name":"simuladoresphet","height":"800","width":"100%","frameborder":"0","src":"https://videotecaedd.s3.amazonaws.com/Simuladores/version-para-moviles/index.html"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }